module.exports = __webpack_public_path__ + "img/logo_1.ebe85646.png";